module.exports = __webpack_public_path__ + "img/account_buy_crypto.fdb5657a.svg";